<template>
	<div>		
		<div id="year-month-chart" style="height: 500px"></div>
	</div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
	name: "ConsumptionChart",
	props: ['data'],
	data() {
		return {
			colors: this.$store.state.colors,
		}
	},
	mounted() {

		// create a bar chart with AMCharts 4
		var chart = am4core.create("year-month-chart", am4charts.XYChart);
		chart.data = this.data

		// create a category axis
		var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = "month";
		categoryAxis.renderer.labels.template.adapter.add("textOutput", (text, target) => {
			return this.monthsNames[parseInt(text) - 1]
		});

		// create a value axis
		chart.yAxes.push(new am4charts.ValueAxis());

		// add a legend
		chart.legend = new am4charts.Legend();

		// create a series
		const years = [...new Set(this.data.map(e => e.year))]
		years.forEach((year, index) => {
			var seriesColor = this.colors[index];
			const data = this.data.filter(e => e.year == year)
			const series = chart.series.push(new am4charts.ColumnSeries());
			series.dataFields.valueY = "value";
			series.dataFields.categoryX = "month";
			series.name = year + '';
			series.stacked = false;
			series.data = data;
			series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
			series.stroke = am4core.color(seriesColor);
			series.columns.template.fill = am4core.color(seriesColor);
		})
	},	
	computed: {
		monthsNames() {
			return this.$store.state.utils.months;
		}
	}
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/BillAudit/Charts/ConsumptionChart.vue